/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Special_Needs_Education27Inputs */

const en__field__enum_studyprograms_study_special_needs_education27 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Special_Needs_Education27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Special Needs Education`)
};

const de__field__enum_studyprograms_study_special_needs_education27 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Special_Needs_Education27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehramt für Förderschulen`)
};

/**
* | output |
* | --- |
* | "Special Needs Education" |
*
* @param {_Field__Enum_Studyprograms_Study_Special_Needs_Education27Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_special_needs_education27 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Special_Needs_Education27Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Special_Needs_Education27Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_special_needs_education27(inputs)
	return de__field__enum_studyprograms_study_special_needs_education27(inputs)
});
export { _field__enum_studyprograms_study_special_needs_education27 as "_field__enum_studyPrograms_STUDY_SPECIAL_NEEDS_EDUCATION" }